// The production page and the API share a host. The load balancer sends /api/* to the backend.
// A container may replace public/config.js at start (API_BASE_URL). That value is not a Vite build arg.
// There is no localhost fallback: a missing or unsafe value stays on same-origin /api.

export const SAME_ORIGIN_API_BASE = '/api'

const RELATIVE_BASE = /^\/[A-Za-z0-9._~/-]*$/

export function resolveApiBase(runtimeBase?: string | null): string {
  if (typeof runtimeBase !== 'string') return SAME_ORIGIN_API_BASE
  const trimmed = runtimeBase.trim().replace(/\/+$/, '')
  if (!trimmed || trimmed === '/') return SAME_ORIGIN_API_BASE
  if (trimmed.startsWith('/') && !trimmed.startsWith('//') && RELATIVE_BASE.test(trimmed)) {
    return trimmed
  }
  if (!isHttpBase(trimmed)) return SAME_ORIGIN_API_BASE
  return trimmed
}

function isHttpBase(value: string): boolean {
  if (!/^https?:\/\//i.test(value)) return false
  try {
    const url = new URL(value)
    if (url.username || url.password) return false
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

export function apiBaseFromWindow(
  config: { apiBase?: unknown } | null | undefined = typeof window === 'undefined'
    ? undefined
    : window.__DRAGONKEEP_CONFIG__,
): string {
  const raw = config && typeof config.apiBase === 'string' ? config.apiBase : null
  return resolveApiBase(raw)
}

declare global {
  interface Window {
    __DRAGONKEEP_CONFIG__?: {
      apiBase?: string
    }
  }
}
